/**
 * jQuery actions to make ajax happen
 */
jQuery(document).ready(function ($) {
  $( '.posts-filter-btn' ).on( 'click', (e) => {
    const filterBtns = document.querySelectorAll('.posts-filter-btn');
    const filterbtns = [...filterBtns];
    filterbtns.forEach((btn) => {
      btn.dataset.active = 'false';
    });
    e.preventDefault();
    e.target.dataset.active = 'true';
    let slug = e.target.dataset.slug;
    jQuery.ajax({
      type: 'POST',
      url: flexurity__posts_filters_ajax.ajaxurl,
      data: {
        action: 'filter_posts',
        payload: slug,
        nonce: flexurity__posts_filters_ajax.security
      },
      beforeSend: function () {
        $('.replaceable_posts').addClass( 'loading' );
      },
      success: function (response) {
        $('#replaceable_posts').html(response);
      },
      error: function (error) {
        console.log(error);
      },
      complete: function () {
        $('.replaceable_posts').removeClass( 'loading' );
      }
    });
  });

});

/**
 * Reading time
 */
function readingTime() {

  const wordCounts = document.querySelectorAll( '#wordcount' );
  const wordcounts = [...wordCounts];

  const wpm = 250;

  wordcounts.forEach( (words) => {
    let time = Math.ceil ( parseInt(words.value) / wpm );
    let id = words.dataset.postId;
    let readingTime = document.querySelector( '.reading-time[data-post-id="' + id + '"');
    readingTime.innerText = time;
  });
}
readingTime();